"use client"

import type { UnlikelyCollection } from "@unlikelystudio/commerce-connector"

import type { PropsWithClassName } from "~/@types/generics"
import serializeLink from "~/components/ui/Link/_data/serializer"
import EndOfPageDispatchV2 from "~/components/slices/EndOfPageDispatchV2"

type ClientEndOfPageDispatchProps = PropsWithClassName<{
  locale: string
  collections: UnlikelyCollection[]
}>

function ClientEndOfPageDispatch({ className, locale, collections }: ClientEndOfPageDispatchProps) {
  if (!collections) return null
  const links = collections
    ?.map((collection) => {
      return {
        children: collection.title ?? "",
        ...serializeLink(collection, locale),
      }
    })
    ?.filter(Boolean)

  return <EndOfPageDispatchV2 className={className} title={"product_end_of_page_dispatch_title"} links={links} />
}

export default ClientEndOfPageDispatch
